import { $el } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../components/base-component'

export class VideoElement extends BaseComponent {
  video: HTMLVideoElement

  constructor() {
    super()
  }

  mountComponent(): void {
    const video: HTMLVideoElement = $el('video', this)
    const hasControls = video.hasAttribute('controls')

    if (!hasControls) {
      this.addListener(this.parentElement, 'click', this.handleClick)
      this.video = video
    }
  }

  handleClick = (): void => {
    if (this.video.paused) {
      this.video.play()
    } else {
      this.video.pause()
    }
  }
}
